<!-- apply ngbTooltip (single-select only) to app-ace-select as ng-select's input overlay blocks #labelTemplate mouse events,
 meaning any tootip applied directly to #labelTemplate would never be displayed-->
<app-ace-select
  #aceSelect
  container="body"
  tooltipClass="favourites-select-tooltip"
  [ngbTooltip]="!multiSelect && selectedFavourites && !aceSelect.isOpen() ? singleItemTooltip : null"
  [openDelay]="TOOLTIP_OPEN_DELAY_MS"
  [tooltipContext]="!multiSelect && selectedFavourites && !aceSelect.isOpen() ? {item: selectedFavourites} : {}"
  [items]="favouriteOptions"
  [multiSelect]="multiSelect"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [placeholder]="placeholder"
  [loading]="loading"
  [compareWith]="compareFn"
  [hideSelected]="hideSelected"
  [appendTo]="appendTo"
  [isReadOnly]="isReadOnly"
  [closeOnSelect]="!multiSelect"
  (shown)="loadContentForTooltip()">

    <ng-template #labelTemplate let-item="item" let-clear="clear">
      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      <span class="ng-value-label">{{ getDisplayName(item) }}</span>
    </ng-template>

    <ng-template #multiLabelTemplate let-items="items" let-clear="clear">
      @if (items.length <= MAX_ITEMS) {
        <div>
          @for (item of items; track item.fav_id) {
            <div class="ng-value">
              <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label"
                    container="body"
                    tooltipClass="favourites-select-tooltip"
                    [ngbTooltip]="singleItemTooltip"
                    [openDelay]="TOOLTIP_OPEN_DELAY_MS"
                    [tooltipContext]="{item}"
                    (shown)="loadContentForTooltip()">{{ getDisplayName(item) }}</span>
            </div>
          }
        </div>
      } @else {
        <div>
          <div class="ng-value">
            <span class="ng-value-label"
                  container="body"
                  tooltipClass="favourites-select-tooltip"
                  [ngbTooltip]="groupedItemsTooltip"
                  [openDelay]="TOOLTIP_OPEN_DELAY_MS"
                  [tooltipContext]="{items}"
                  (shown)="loadContentForTooltip()">{{ 'count favourites selected' | messageTranslate:{count: items.length} }}</span>
          </div>
        </div>
      }
    </ng-template>

    <ng-template #optionTemplate let-item="item">
      <span class="ng-value-label"
            container="body"
            tooltipClass="favourites-select-tooltip"
            [ngbTooltip]="singleItemTooltip"
            [openDelay]="TOOLTIP_OPEN_DELAY_MS"
            [tooltipContext]="{item: item}"
            (shown)="loadContentForTooltip()">{{ getDisplayName(item) }}</span>
    </ng-template>

    <ng-template #singleItemTooltip let-fav="item">
      <strong>{{fav?.metadata?.name}}</strong>
      @if (fav && !fav.zone.system) {
       - {{fav.zone.level.level_name}}, {{fav.zone.zone_name.zone_name}}
      }
      @if (includeIdentifierInTooltip) {
        @if (deviceObjectFetchSubscription) {
          <br /><span class="fw-bold">{{'Loading details...' | messageTranslate}}</span>
        } @else {
          @let deviceObject = (deviceObjectsById && fav?.device_object_id != null)
            ? (deviceObjectsById.get(fav.device_object_id) ?? null)
            : null;
          @if (deviceObject) {
            <br>{{'BACnet ID' | messageTranslate}}: {{deviceObject.device.bacnet_device_id}}
            <br>{{'Identifier' | messageTranslate}}: {{deviceObject.object_identifier}}
            <br>{{'Name' | messageTranslate}}: {{deviceObject.object_name}}
          } @else {
            <br>{{'Identifier' | messageTranslate}}: {{fav?.identifier}}
          }
        }
      }
    </ng-template>

    <ng-template #groupedItemsTooltip let-favs="items">
      @let showBacnetColumns = includeIdentifierInTooltip && favs.some(hasBacnetObject);
      <table class="cim-tooltip">
        <thead>
        <tr>
          <th>{{'Name' | messageTranslate}}</th>
          <th>{{'Level' | messageTranslate}}</th>
          <th>{{'Zone' | messageTranslate}}</th>
          @if (includeIdentifierInTooltip && !deviceObjectFetchSubscription) {
            @if (showBacnetColumns) {
              <th>{{'BACnet ID' | messageTranslate}}</th>
              <th>{{'Identifier' | messageTranslate}}</th>
              <th>{{'Name' | messageTranslate}}</th>
            } @else {
              <th>{{'Identifier' | messageTranslate}}</th>
            }
          }
        </tr>
        </thead>
        <tbody>
          @for (fav of favs; track fav.fav_id) {
            <tr>
              <td><strong>{{fav.metadata.name}}</strong></td>
              <td>
                @if (!fav.zone.system) {
                  {{fav.zone.level.level_name}}
                }
              </td>
              <td>
                @if (!fav.zone.system) {
                  {{fav.zone.zone_name.zone_name}}
                }
              </td>
              @if (includeIdentifierInTooltip && !deviceObjectFetchSubscription) {
                @if (showBacnetColumns) {
                  @let deviceObject = (deviceObjectsById && fav?.device_object_id != null)
                    ? (deviceObjectsById.get(fav.device_object_id) ?? null)
                    : null;
                  <td>{{deviceObject?.device?.bacnet_device_id || ''}}</td>
                  <td>{{deviceObject?.object_identifier || fav.identifier}}</td>
                  <td>{{deviceObject?.object_name || ''}}</td>
                } @else {
                  <td>{{fav.identifier}}</td>
                }
              }
            </tr>
          }
        </tbody>
      </table>
      @if (deviceObjectFetchSubscription) {
        <div class="p-2 fw-bold">
          {{'Loading details...' | messageTranslate}}
        </div>
      }
    </ng-template>

</app-ace-select>
